<template>
    <div
        :id="id"
        class="progress-wrapper"
    >
        <div class="bar-container">
            <div
                class="progress-bar"
                :style="{ width: `${progressValue}%` }"
            />
        </div>
        <div
            v-if="showLabel"
            :style="{ marginLeft: `${progressValue}%` }"
        >
            <div
                class="label"
                :class="progressValue < 10 ? 'almost-start' : progressValue > 90 ? 'almost-end' : undefined"
            >
                {{ progressValue.toFixed(0) }}%
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { clamp } from 'ramda'
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    progress: number
    showLabel?: boolean
}>()

const progressValue = computed(() => {
    return clamp(0, 100, isNaN(+props.progress) ? 0 : +props.progress)
})


</script>

<style lang="sass" scoped>
@import './ProgressBar.sass'
</style>
